import * as React from "react";
import { TableHeaderRow } from "../TableHeaderRow/TableHeaderRow";
import { AssetClassGroup } from "../AssetClassGroup/AssetClassGroup";
import * as rankiaData from "../../../data/rankia.data";

const styles = require('../FundNameRow/FundNameRow.pcss');

interface LProps {
    table?: any;
    funds?: {};
    sorting?: any;
}

export class PerformanceTable extends React.Component<LProps, {}>{
    constructor(props) {
        super(props);
    }

    render() {
        let funds = this.props.funds;
        let sort = this.props.sorting;
        return this.renderTable(funds["funds"], funds["identifiers"], funds["translationGroup"], sort, rankiaData.DISCLAIMER);
    }

    renderTable(fundlist, identifiers, translations, sort, disc) {
        let groups = [];
        let disclaimerList = disc.map((disc, i) => (i === 0) ? <p key={i}><b>{disc}</b></p> : <p key={i}>{disc}</p>);
        this.getAssetClassGroups(groups, fundlist, identifiers, sort, translations["data"], translations["sector"]);
        return (
            <div className="">
                <div className={styles.responsiveDiv}>
                    <table className={styles.hoverTable}>
                        <thead>
                            <TableHeaderRow headerProps={identifiers} translations={translations["label"]} />
                        </thead>
                        {groups}
                    </table>
                </div>
                <ul className={styles.footnote}>
                    <li>{disclaimerList}</li>
                </ul>
            </div>
        );
    }

    getAssetClassGroups(g, list, idents, sort, dataTranslations, sectorTranslations) {
        let groupedList = [];
        if (list.length > 0 && idents.length > 0) {
            groupedList = this.buildAssetGroup(list, idents, 'assetClass');
        }
        for (let i = 0; i < groupedList.length; i++) {
            groupedList[i] = sort(groupedList[i], "name");
            g.push(<AssetClassGroup key={"group" + i} fundNames={groupedList[i]} isins={groupedList[i]} translations={dataTranslations} sectorTranslations={sectorTranslations} />);
        }
    }

    buildAssetGroup(list, idents, assetClass) {
        list = this.joinIdentifiers(list, idents);
        list = this.groupByAssetClass(list, assetClass);
        return this.buildFundNames(list);
    }

    joinIdentifiers(list, idents) {
        for (let k = 0; k < list.length; k++) {
            list[k].isin = idents[k].isin;
            list[k].stats = idents[k].statistics;
            list[k].benchMarkData = idents[k].benchMarkObj;
            list[k].shareClassType = idents[k].shareClassType;
        }
        return list;
    }

    groupByAssetClass(arr, property) {
        let i = 0;
        let assocArr = arr.reduce((item, i) => {
            if (!item[i[property]]) {
                item[i[property]] = [];
            }
            item[i[property]].push(i);
            return item;
        }, []);
        assocArr = assocArr.reverse();
        for (let p in assocArr) {
            assocArr[i] = assocArr[p];
            delete assocArr[p];
            i++;
        } //replace with numeric indices
        return assocArr;
    }

    buildFundNames(groupedList) {
        if (groupedList)
            groupedList.reduce((prev, curr) => prev.concat(curr)).forEach((el) => {
                el.name += ' ' + el.shareClassType.shareClassCurrencyName + ' ' + el.shareClassType.shareClassLetter + ' - ' + el.shareClassType.shareTypeAbbrev;
            });
        return groupedList;
    }

}



// WEBPACK FOOTER //
// ./src/client/Rankia/Components/PerformanceTable/PerformanceTable.tsx